import React, { useMemo } from 'react';

function SQLPrintCell({ row, header }) {
    const value = useMemo(() => {
        const { field, valueFormatter, component } = header;
        if (component) return component(row[field]);
        if (valueFormatter) return valueFormatter(row[field]);
        return row[field];
    }, [header, row]);

    return (
        <td>{value}</td>
    );
}

export default function SQLPrintTable({ headers, showIndex, data }) {
    return (
        <table className="printable-fetura-grid">
            <thead>
                <tr>
                    {
                        showIndex && <th>#</th>
                    }
                    {
                        headers.map(header => <th key={header.field}>{header.name}</th>)
                    }
                </tr>
            </thead>
            <tbody>
                {
                    data.map((row, index) => {
                        return (
                            <tr key={index}>
                                {
                                    showIndex && <td>{index + 1}</td>
                                }
                                {
                                    headers.map(header => <SQLPrintCell key={header.field} header={header} row={row} />)
                                }
                            </tr>
                        );
                    })
                }
            </tbody>
        </table>
    );
}
